export default {"src":"/_next/static/media/paxg.646e42fc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};